import { render, staticRenderFns } from "./visualizador-pdf.vue?vue&type=template&id=4940a8cf&"
import script from "./visualizador-pdf.component.ts?vue&type=script&lang=ts&"
export * from "./visualizador-pdf.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports